import {ChangeDetectionStrategy, Component, computed, input, output} from '@angular/core';
import {bzIconChevronDownTk, bzIconChevronRightTk} from '@bringoz/ui/icons';
import * as _ from 'lodash';
import {TimeCardModel} from '../../models/timecard.model';
import {TimeCardGroup} from '../../models/timecard-group.model';
import {TimeCardStatusType} from '../../../types/timecard-status.type';
import {TimekeepingColumnsMap} from '../../models/timekeeping-list.model';
import {TimecardRowSelectEvent} from '../timecard-table-row/timecard-table-row.component';

const APPROVED_STATUSES: string[] = [TimeCardStatusType.Approved, TimeCardStatusType.Completed];

require('./timecard-entry-row.scss');
@Component({
  standalone: false,
  selector: 'timecard-entry-row',
  templateUrl: './timecard-entry-row.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class TimecardEntryRowComponent {

  /** Tree connector: the last day of an agent ends the line, the others continue it. */
  readonly icons = {child: bzIconChevronDownTk, lastChild: bzIconChevronRightTk};

  readonly timecard = input<TimeCardModel>();
  readonly group = input<TimeCardGroup>();
  readonly dayName = input<string>();
  readonly date = input<Date>();
  readonly index = input<number>();
  readonly isLastChild = input<boolean>(false);
  readonly isSelected = input<boolean>(false);
  readonly columns = input<TimekeepingColumnsMap>({});

  readonly timecardSelect = output<TimecardRowSelectEvent>();
  readonly selectToggle = output<TimeCardModel>();

  readonly isApproved = computed(() => _.includes(APPROVED_STATUSES, this.timecard()?.status));

  onRowSelect(): void {
    if (!this.timecard()) {
      return;
    }
    this.timecardSelect.emit({timecard: this.timecard(), group: this.group(), date: this.date()});
  }

  onCheckboxToggle(): void {
    if (!this.timecard()) {
      return;
    }
    this.selectToggle.emit(this.timecard());
  }
}
